class AdWidget {

    constructor($sce) {

        return {
            restrict: 'E',
            scope: {
            	widget: "="
            },
            link: ($scope, $el, $attr) => {
                $el.html($scope.widget.icon);
            	$el.data("reflow-asset", $scope.widget);
                $el.draggable({
                    helper: "clone",
                    cursor: '-webkit-grabbing',
                    cursorAt: {
                        left: 0,
                        top: 0
                    },
                    appendTo: "body",
                    containment: "body"
            	});
            }
        };

   	}

}

angular.module('cpm')
    .directive('adWidget', ["$sce", ($sce) => {
        'use strict';
        return new AdWidget($sce);
    }]);
